import { render, staticRenderFns } from "./bindStaffNo.vue?vue&type=template&id=66503c88&scoped=true&"
import script from "./bindStaffNo.vue?vue&type=script&lang=js&"
export * from "./bindStaffNo.vue?vue&type=script&lang=js&"
import style0 from "./bindStaffNo.vue?vue&type=style&index=0&id=66503c88&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66503c88",
  null
  
)

export default component.exports